export default __webpack_public_path__ + "static/media/010-wear gloves.5812fbdf.svg";